export const useGetLegalLinks = (country: string) => {
  const baseLink = () => {
    if (process.env.REACT_APP_STAGE === 'prod') {
      return 'https://legal.hconnect.digital'
    } else {
      return `https://legal-${process.env.REACT_APP_STAGE}.hconnect.digital`
    }
  }
  const imprintLink = `${baseLink()}/policies/imprint/${country}`
  const tcLink = `${baseLink()}/policies/tc/${country}`
  const ossLink = `${baseLink()}/ossattribution`
  const dppLink = `${baseLink()}/policies/dpp/${country}`

  return {imprintLink, tcLink, ossLink, dppLink}
}
